export default __webpack_public_path__ + "cb007b70a24ef2b22d187d64e0248768.jpg";